import { useNavigate, useParams } from "react-router";
import { useAuth } from "@/auth/AuthContext";
import { CreateEntityModal } from "@/components/CreateEntityModal";
import { hasRole } from "@/lib/hasRole";
import { EntityListPage } from "./EntityListPage";
import { useEntityList } from "./useEntityList";

interface Connector {
  id: string;
  name: string;
  createdAt: string;
  lastSeenAt: string | null;
}

export function Connectors() {
  const { user } = useAuth();
  const { orgId } = useParams();
  const navigate = useNavigate();
  const list = useEntityList<Connector>("connectors");
  const isAdmin = hasRole(user?.roles, "Admin");

  return (
    <>
      {isAdmin && <CreateEntityModal entityType="connector" />}

      <EntityListPage
        list={list}
        entityLabel="connector"
        entityLabelPlural="connectors"
        emptyDescription="Connectors route connections from gateways to resources on private networks."
        menuItems={
          isAdmin
            ? (connector) => [
                {
                  label: "Details",
                  onClick: () =>
                    navigate(
                      `/${orgId}/networking/connectors/${connector.id}/details`,
                    ),
                },
                {
                  label: "Resources",
                  onClick: () =>
                    navigate(
                      `/${orgId}/networking/connectors/${connector.id}/resources`,
                    ),
                },
                {
                  label: "Settings",
                  onClick: () =>
                    navigate(
                      `/${orgId}/networking/connectors/${connector.id}/settings`,
                    ),
                },
              ]
            : undefined
        }
      />
    </>
  );
}
